import React from 'react';

import { Alert } from 'components/shared/Alert';
import { EOrganizedBy } from 'detailsv2/structure';

import s from '../FlightTabs.module.css';

type Props = {
  organizedBy: EOrganizedBy;
  children: React.ReactNode;
};

export const Content = (props: Props) => {
  return (
    <div className={s.contentContainer}>
      {props.organizedBy === EOrganizedBy.Day && (
        <Alert
          className={s.alert}
          variant="info"
          content="To search by flight number or route the itinerary must be Organized by Date."
        />
      )}
      {props.children}
    </div>
  );
};
